import React, { useState } from 'react';
import ErrorPopupLayout from '../layouts/ErrorPopupLayout';
import { Close } from '../icons/Close';
const FileSizePopup = ({ file_size_warning_title, file_type_warning_title, file_size_warning_text, file_size_warning_btn, file_px_warning_text, file_type_warning_text, file_generic_warning_text, file_large_warning_title, file_small_warning_title, upload_count_title, upload_count_warning, file_error_warning_text, file_error_warning_title, warningType, handleReset, }) => {
    const [handleDisplay, setHandleDisplay] = useState(true);
    const handlePopupDisplay = () => {
        handleReset();
        setHandleDisplay(false);
    };
    const renderTitle = (warning) => {
        switch (warning) {
            case 'fileSize':
                return file_size_warning_title;
            case 'fileType':
                return file_type_warning_title;
            case 'fileLarge':
                return file_large_warning_title;
            case 'fileSmall':
                return file_small_warning_title;
            case 'fileUpload':
                return file_error_warning_title;
            case 'maxUploads':
                return upload_count_title;
            default:
                return 'Oh no!';
        }
    };
    const renderWarningMessage = (warning) => {
        switch (warning) {
            case 'fileSize':
                return file_size_warning_text;
            case 'fileType':
                return file_type_warning_text;
            case 'fileLarge':
                return file_px_warning_text;
            case 'fileSmall':
                return file_px_warning_text;
            case 'fileUpload':
                return file_error_warning_text;
            case 'maxUploads':
                return upload_count_warning;
            default:
                return file_generic_warning_text;
        }
    };
    return (React.createElement(React.Fragment, null, handleDisplay && (React.createElement(ErrorPopupLayout, null,
        React.createElement("button", { className: "hg-modal__warning--close", "aria-label": "close", onClick: handlePopupDisplay },
            React.createElement(Close, null)),
        React.createElement("h2", { className: "hg-modal__warning--title" }, renderTitle(warningType)),
        React.createElement("p", { className: "hg-modal__warning--text" }, renderWarningMessage(warningType)),
        React.createElement("div", { className: "hg-modal__warning--buttons" },
            React.createElement("button", { className: "btn btn--solid", style: { maxWidth: '170px' }, onClick: handlePopupDisplay }, file_size_warning_btn))))));
};
export default FileSizePopup;
